<template>
  <div class="language-switcher">
    <form
      method="post"
      ref="languageForm"
      action="/localization"
      id="language-switcher-form"
      accept-charset="UTF-8"
      class="localization-form"
      enctype="multipart/form-data"
    >
      <input type="hidden" name="form_type" value="localization">
      <input type="hidden" name="_method" value="put">

      <div class="language-switcher__container">
        <ul class="language-switcher__list list-unstyled">
          <li
            v-for="(locale, index) of availableLocales"
            :key="locale.shop_locale.locale"
            class="language-switcher__item"
          >
            <a
              @click.prevent="handleLocaleChange(locale.shop_locale.locale)"
              class="language-switcher__link"
              :class="locale.shop_locale.locale == selectedLocale && 'active'"
              href="#"
              :data-value="locale.shop_locale.locale"
              v-text="locale.shop_locale.locale"
            />

            <span
              v-if="index !== availableLocales.length - 1"
              class="separator"
            />
          </li>
        </ul>
        <input type="hidden" name="locale_code" v-model="selectedLocale">
      </div>
    </form>
  </div>
</template>

<script>

/**
 * Vue: Language switcher (language-switcher)
 * -----------------------------------------------------------------------------
 * Used to switch languages.
 *
 */
export default {
  name: 'LanguageSwitcher',

  data() {
    return {
      cnvsGlobal: true,
      currentLocale: window.cnvs.request.currentLocale,
      availableLocales: window.cnvs.request.availableLocales,
      selectedLocale: window.cnvs.request.currentLocale,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    handleLocaleChange(locale) {
      this.selectedLocale = locale
      this.$nextTick().then(() => {
        this.$refs.languageForm.submit()
      })
    },
  },
}
</script>
